import AppDataService from "./AppDataService";

const COMMON_BASE = "auth";

export default class ProviderProfileService {
  // static async postTaskData(data) {
  //   return await AppDataService.post(`task`, data);
  // }

  static async getProviderTaskList(data) {
    const queryParams = [
      // data?.searchKey ? `searchKey=${data.searchKey}` : "",
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.taskTitle ? `taskTitle=${data.taskTitle}` : "",
      data?.patientName ? `patientName=${data.patientName}` : "",
      data?.assigenTo ? `assigenTo=${data.assigenTo}` : "",
      data?.assigenBy ? `assigenBy=${data.assigenBy}` : "",
      data?.status ? `status=${data.status}` : "",
      data?.dueDate ? `dueDate=${data.dueDate}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`task${queryString}`);
  }

  static async updateEditTaskData(taskId, data) {
    return await AppDataService.patch(`task/${taskId}`, data);
  }

  static async getUserById(id) {
    return await AppDataService.get(`user/${id}`);
  }

  static async updateProfileDetailsData(userId, data) {    
    return await AppDataService.patch(`user/${userId}`, data);
  }

  static async getDepartmentList(data) {
    const queryParams = [
      data?.facilityId ? `facilityId=${data?.facilityId}` : "",
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.name ? `name=${data.name}` : "",
      // data?.status ? `status=${data?.status}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`department${queryString}`);
  }
}
